import React, { Component } from "react";

class Password extends Component {
  state = {
    isPasswordShown: false,
    formclass: "form-group custom-input",
  };

  constructor(props) {
    super(props);
    this.input = React.createRef();
  }

  handleFocus = () => {
    this.setState({ formclass: "form-group custom-input show on" });
  };

  handleBlur = (e) => {
    const classname = e.target.value
      ? "form-group custom-input show on"
      : "form-group custom-input";
    this.setState({ formclass: classname });
  };

  toggleShowPassword = (e) => {
    this.setState({ isPasswordShown: !this.state.isPasswordShown });
    this.input.current.type = this.state.isPasswordShown ? "password" : "text";
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      const classname = this.props.value
        ? "form-group custom-input show on"
        : "form-group custom-input";
      this.setState({ formclass: classname });
    }
  }

  render() {
    const { name, label, error, ...rest } = this.props;

    return (
      <div className={this.state.formclass}>
        <label htmlFor={name}>{label}</label>
        <div className="input-field">
          <input
            name={name}
            id={name}
            className={error ? "form-control error" : "form-control"}
            type="password"
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            ref={this.input}
            {...rest}
          />
          <div onClick={this.toggleShowPassword}>
            {this.state.isPasswordShown ? (
              <i className="fas fa-eye-slash toggle-password"></i>
            ) : (
              <i className="fas fa-eye toggle-password"></i>
            )}
          </div>
          {error && <label className="error">{error}</label>}
        </div>
      </div>
    );
  }
}

export default Password;
